export default function Patrick() {
	return (
		<div className="bio">
			<h3>Patrick Wang</h3>
			<p>BIG BOI</p>
		</div>
	);
}